import type { ResourceConfig } from "../types";

export const messageConfig = {
  displayName: "消息",
  category: "message",
  permissions: {
    "read:all": {
      label: "查看所有未分配消息",
      description: "可以查看所有未分配的消息",
    },
    "write:all": {
      label: "处理所有未分配消息",
      description: "可以处理所有未分配的消息",
    },
    "read:assigned": {
      label: "查看自己负责的消息",
      description: "只能查看分配给自己的消息",
    },
    "write:assigned": {
      label: "处理自己负责的消息",
      description: "只能处理分配给自己的消息",
    },
  },
  scopeStrategy: "byMessageConversation",
  navigation: {
    path: "/unassigned-messages",
    label: "未绑定消息",
    icon: "Bell" as const,
    requiredPermissions: ["read:all", "read:assigned"] as const,
    group: "notification" as const,
  },
} satisfies ResourceConfig;
